import React from 'react';
import Tooltip from 'features/common/SimpleTooltip';
import T from 'i18n';

export const TooltipWrapper = ({
  children,
  isPresenting,
}: {
  children: any;
  isPresenting: boolean;
}) => {
  const info = (
    <>
      <div>{T.translate('case.stopPresentingTooltip')}</div>
    </>
  );

  return isPresenting ? <Tooltip title={info}>{children}</Tooltip> : children;
};
